module.exports = __webpack_public_path__ + "static/media/crunchafi-fieldguide.dac0d706.svg";